import { StylingConfigType } from './configurator'
import tinycolor from 'tinycolor2'
import { CssVar } from '@insided/destination/modules/Customization/ThemeConfigurator'

export const getColors = (): Record<CssVar, string | null> => ({
  'config--main-color-brand': '#2aaae1',
  'config--main-color-brand-secondary': '#2aaae1',
  'config-header-color': '#1a1a1a',
  'config--main-color-night': '#1a1a1a',
  'config-meta-text-color': '#a7aeb5',
  'config-main-navigation-search-placeholder-color': '#a7aeb5',
  'config-body-background-color': '#f0f2f6',
  'config--main-border-base-color': '#d5d7db',
  'config--main-color-success': '#3cb54a',
  'config--main-color-alert': '#ed5937',
  'config--main-color-info': '#f79321',
  'config-topic-question-color': '#f79321',
  'config--main-color-disabled': '#f6f8fa',
  'config-notification-widget-background-color': null,
  'config-notification-widget-color': '#fff',
  'config-widget-cta-background-color': '#ffffff00',
  'config-widget-cta-color': null,
  'config-hero-color': '#fff',
  'config-subcategory-hero-color': '#fff'
})

export const getButtons = (existingSettings: StylingConfigType) => ({
  'config-button-cta-background-color': existingSettings['config--main-color-brand'],
  'config-button-secondary-background-color': existingSettings['config--main-color-brand-secondary'],
  'config-button-toggle-background-color': '#00000000',
  'config-button-toggle-on-background-color': tinycolor(existingSettings['config--main-color-brand'] ?? undefined).setAlpha(0.6).toHex8String(),
  'config-button-cancel-background-color': '#00000000',
  'config-button-cta-color': '#ffffff',
  'config-button-secondary-color': '#ffffff',
  'config-button-toggle-color': existingSettings['config--main-color-brand'],
  'config-button-toggle-on-color': '#ffffff',
  'config-button-cancel-color': existingSettings['config--main-color-alert'],
  'config-button-cta-border-color': existingSettings['config--main-color-brand'],
  'config-button-cta-hover-border-color': existingSettings['config--main-color-brand'],
  'config-button-cta-active-border-color': existingSettings['config--main-color-brand'],
  'config-button-secondary-border-color': existingSettings['config--main-color-brand-secondary'],
  'config-button-secondary-hover-border-color': existingSettings['config--main-color-brand-secondary'],
  'config-button-secondary-active-border-color': existingSettings['config--main-color-brand-secondary'],
  'config-button-toggle-border-color': existingSettings['config--main-color-brand'],
  'config-button-toggle-hover-border-color': existingSettings['config--main-color-brand'],
  'config-button-toggle-active-border-color': existingSettings['config--main-color-brand'],
  'config-button-toggle-on-border-color': existingSettings['config--main-color-brand'],
  'config-button-toggle-on-hover-border-color': existingSettings['config--main-color-brand'],
  'config-button-toggle-on-active-border-color': existingSettings['config--main-color-brand'],
  'config-button-cancel-border-color': existingSettings['config--main-color-alert'],
  'config-button-cancel-hover-border-color': existingSettings['config--main-color-alert'],
  'config-button-cancel-active-border-color': existingSettings['config--main-color-alert'],
  'config-button-cta-box-shadow': null,
  'config-button-cta-hover-box-shadow': null,
  'config-button-cta-active-box-shadow': null,
  'config-button-secondary-box-shadow': null,
  'config-button-secondary-hover-box-shadow': null,
  'config-button-secondary-active-box-shadow': null,
  'config-button-toggle-box-shadow': null,
  'config-button-toggle-hover-box-shadow': null,
  'config-button-toggle-active-box-shadow': null,
  'config-button-toggle-on-box-shadow': null,
  'config-button-toggle-on-hover-box-shadow': null,
  'config-button-toggle-on-active-box-shadow': null,
  'config-button-cancel-box-shadow': null,
  'config-button-cancel-hover-box-shadow': null,
  'config-button-cancel-active-box-shadow': null,
  'config-button-cta-hover-background-color': tinycolor(existingSettings['config--main-color-brand'] ?? undefined).darken(10).toHex8String(),
  'config-button-secondary-hover-background-color': tinycolor(existingSettings['config--main-color-brand-secondary'] ?? undefined).darken(10).toHex8String(),
  'config-button-toggle-hover-background-color': tinycolor(existingSettings['config--main-color-brand'] ?? undefined).darken(10).toHex8String(),
  'config-button-toggle-on-hover-background-color': tinycolor(existingSettings['config--main-color-brand'] ?? undefined).darken(10).toHex8String(),
  'config-button-cancel-hover-background-color': tinycolor(existingSettings['config--main-color-alert'] ?? undefined).darken(10).toHex8String(),
  'config-button-cta-hover-color': '#ffffff',
  'config-button-secondary-hover-color': '#ffffff',
  'config-button-toggle-hover-color': existingSettings['config--main-color-brand'],
  'config-button-toggle-on-hover-color': '#ffffff',
  'config-button-cancel-hover-color': existingSettings['config--main-color-alert'],
  'config-button-cta-active-background-color': tinycolor(existingSettings['config--main-color-brand'] ?? undefined).darken(15).toHex8String(),
  'config-button-secondary-active-background-color': tinycolor(existingSettings['config--main-color-brand'] ?? undefined).darken(15).toHex8String(),
  'config-button-toggle-active-background-color': tinycolor(existingSettings['config--main-color-brand'] ?? undefined).setAlpha(0.15).toHex8String(),
  'config-button-toggle-on-active-background-color': tinycolor(existingSettings['config--main-color-brand'] ?? undefined).setAlpha(0.8).toHex8String(),
  'config-button-cancel-active-background-color': tinycolor(existingSettings['config--main-color-alert'] ?? undefined).setAlpha(0.15).toHex8String(),
  'config-button-cta-active-color': '#ffffff',
  'config-button-secondary-active-color': '#ffffff',
  'config-button-toggle-active-color': existingSettings['config--main-color-brand'],
  'config-button-toggle-on-active-color': '#ffffff',
  'config-button-cancel-active-color': existingSettings['config--main-color-alert'],
  'config-button-border-radius': '3px',
  'config-button-border-width': '0',
  'config--main-button-base-font-weight': '400',
  'config--main-button-base-texttransform': 'none'
})

export const getCards = () => ({
  'config-card-border-radius': '3px',
  'config-card-border-width': '0',
  'config-card-background-color': '#ffffff',
  'config-card-title-color': null,
  'config-card-text-color': null,
  'config-card-border-color': null,
  'config-card-shadow': null,
  'config-card-hover-background-color': '#ffffff',
  'config-card-hover-title-color': null,
  'config-card-hover-text-color': null,
  'config-card-hover-border-color': null,
  'config-card-hover-shadow': '0 5px 20px 0 rgba(0, 0, 0, 0.08)',
  'config-card-active-background-color': '#ffffff',
  'config-card-active-title-color': null,
  'config-card-active-text-color': null,
  'config-card-active-border-color': null,
  'config-card-active-shadow': null
})

export const getFonts = () => ({
  'config--main-font-base-stack': 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
  'config--main-font-secondary': 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
  'config--main-button-base-font-family': 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif'
})
